import { render } from "./QueuedActivitiesTable.vue?vue&type=template&id=645da33a&scoped=true"
import script from "./QueuedActivitiesTable.vue?vue&type=script&lang=js"
export * from "./QueuedActivitiesTable.vue?vue&type=script&lang=js"

import "./QueuedActivitiesTable.vue?vue&type=style&index=0&id=645da33a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645da33a"]])

export default __exports__